/* jslint browser: true */
import React, { Component } from 'react';
import ReactTable                from 'react-table';
import moment                    from 'moment';

class CommandesPro extends Component {
    
    constructor(props){
        super(props);
        
        this.state = {
          ordersColumns :
            [
                {
                    id       : 'date',
                    Header   : 'Date',
                    width    : 100,
                    accessor : d => moment(d.date).format('DD[/]MM[/]YYYY'),
                }, {
                    id       : 'description',
                    Header   : 'Description',
                    accessor : d => d.description
                }, {
                    id       : 'download',
                    Header   : 'Télécharger',
                    width    : 100,
                    accessor : d => d.factureURL,
                    Cell     : _props => (
                        <span className="number">
                            <a href={_props.value} target="_blank">Télécharger</a>
                        </span>
                    )
                },
            ]
        };
    }
    
    render() {
        return <div className="pro-orders" style={this.props.style}>
            <h3>MES COMMANDES</h3>
            <ReactTable
                columns={this.state.ordersColumns}
                data={this.props.commandes}
                defaultPageSize={5}
                previousText="Précédent"
                nextText="Suivant"
                loadingText="Chargement..."
                noDataText="Aucune information"
                ofText="sur"
                rowsText="lignes"
                showPageSizeOptions={false}
                />
            </div>;
    }
}

export default CommandesPro;


// WEBPACK FOOTER //
// ./src/components/commande/CommandesPro.js